// removed by extract-text-webpack-plugin
module.exports = {"link":"FileUploader_link_3ZFSZ","error":"FileUploader_error_2H-Dn"};